<template>
  <div>
    <div class="navigation">
      <div class="navigation_bottom">
        <img class="ai_assistant" ref="ai_assistant"
          src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/AI_Ass/AI_Ass.png" alt="">
        <span ref="scroll_bottom" class="scroll_bottom iconfont" @click="scrollToBottom">&#xe685; 回到底部</span>
      </div>
      <div class="navigation_items" ref="navigation_items">
        <div class="main_input" ref="main_input">
          <!-- 已上传图片缩略图区域 -->
          <div v-if="uploadImages.length > 0" class="uploaded-thumbnails">
            <div v-for="(img, idx) in uploadImages" :key="idx" class="thumbnail-item">
              <img :src="img" alt="上传图片" class="thumbnail-img">
              <div class="remove-btn" @click.stop="removeImage(idx)">×</div>
            </div>
          </div>
          <!-- 输入框区域 -->
          <div class="input-area">
            <textarea name="" id="" placeholder="描述你想要的色卡修图效果（可选）..."
              v-model="textarea"
              @focus="handleTextareaFocus"
              @input="handleTextareaInput"
              @blur="handleTextareaBlur"
              @click="handleTextareaClick"
              :disabled="processing"></textarea>
            <button ref="up" class="sent iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="!scrollStatus" :disabled="!canSend || processing">
              <span v-if="!processing">&#xe688;</span>
              <span v-else class="rotating">&#xe6a4;</span>
            </button>
          </div>
          <!-- 底部功能按钮行 - 在输入框下方 -->
          <div class="input-options" @click.stop>
            <!-- 上传按钮 -->
            <div class="option-btn" @click.stop="handleImageUpload">
              <span>+上传</span>
            </div>
            <!-- 图像大小按钮 -->
            <div class="option-btn image-size-btn">
              <span>图像大小：2K</span>
            </div>
          </div>
        </div>
        <!-- 放大后的发送按钮（绝对定位） -->
        <button ref="down" class="sent_expanded iconfont" :class="{ 'has_input': canSend }" @click.stop="startTask" v-show="scrollStatus" :disabled="!canSend || processing">
          <span v-if="!processing">&#xe688;</span>
          <span v-else class="rotating">&#xe6a4;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { getOssClient } from '@/utils/oss'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { getLastUsedBaseUrl, getWebSocketUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import colorCardWorkflow from '@/api/json_api/色卡修图qwen_edit_2511.json'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { T_COLOR_CARD_RETouchING } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'NaviGation_ColorCard',
  props: {
    initialChatHistory: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      textarea: '',
      uploadImages: [], // 上传的图片URL数组（最多10张）
      processing: false,
      colorcardChatHistory: [],
      scrollStatus: false,
      // WebSocket
      ws: null,
      clientId: '',
      // 防止重复获取图片标志
      imageFetched: false,
      // 任务日志ID
      taskLogId: null,
      // OSS 配置
      ossConfig: {
        accessKeyId: OSS_ACCESS_KEY_ID,
        accessKeySecret: OSS_ACCESS_KEY_SECRET
      },
      // 节点名称映射
      nodeNameMap: {
        1: 'In AI image generation',
        5: 'Analyze prompt',
        6: 'Generate random seed',
        7: 'Load image',
        8: 'Upload generated results',
        9: 'Apply LLM',
        10: 'Process prompt',
        11: 'Load model',
        12: 'Encode image',
        13: 'Decode image',
        14: 'KSampler',
        15: 'Save image',
        16: 'Preview image',
        17: 'VAE encode',
        18: 'VAE decode',
        19: 'CLIP text encode',
        20: 'CLIP vision encode',
        21: 'Load checkpoint',
        22: 'Load VAE',
        23: 'Load CLIP',
        24: 'Conditioning',
        25: 'Model sampling',
        26: 'Image scaling',
        27: 'Image composite',
        28: 'Mask processing',
        29: 'Denoise',
        30: 'Upscale',
        31: 'Face restore',
        32: 'Color correction',
        33: 'Prompt processing',
        34: 'Text generation',
        35: 'Image generation',
        36: 'Video generation',
        37: 'Audio processing',
        38: 'Model loading',
        39: 'Data preprocessing',
        40: 'Post processing',
        41: 'Batch processing',
        42: 'Queue management',
        43: 'Memory management',
        44: 'GPU allocation',
        45: 'Thread scheduling',
        46: 'Cache management',
        47: 'Network request',
        48: 'File I/O',
        49: 'Database operation',
        50: 'Configuration load',
        51: 'Parameter validation',
        52: 'Error handling',
        53: 'Logging',
        54: 'Monitoring',
        55: 'Security check',
        56: 'Authentication',
        57: 'Authorization',
        58: 'Session management',
        59: 'State sync',
        60: 'Event dispatch',
        61: 'Callback execution',
        62: 'Promise resolution',
        63: 'Async await',
        64: 'Stream processing',
        65: 'Buffer management',
        66: 'Compression',
        67: 'Decompression',
        68: 'Encryption',
        69: 'Decryption',
        70: 'Hash calculation',
        71: 'Checksum verify',
        72: 'Data transformation',
        73: 'Format conversion',
        74: 'Protocol handling',
        75: 'Socket communication',
        76: 'HTTP request',
        77: 'WebSocket',
        78: 'MQTT publish',
        79: 'Redis operation',
        80: 'MongoDB query',
        81: 'SQL execution',
        82: 'Index building',
        83: 'Search query',
        84: 'Sort operation',
        85: 'Filter apply',
        86: 'Aggregation',
        87: 'Map reduce',
        88: 'Graph traversal',
        89: 'Tree balancing',
        90: 'Heap operation',
        91: 'Stack processing',
        92: 'Queue enqueue',
        93: 'Deque operation',
        94: 'Linked list',
        95: 'Array sort',
        96: 'Matrix operation',
        97: 'Vector calculation',
        98: 'Tensor operation',
        99: 'Neural network',
        100: 'Layer forward',
        101: 'Back propagation',
        102: 'Gradient descent',
        103: 'Weight update',
        104: 'Bias adjustment',
        105: 'Activation function',
        106: 'Loss calculation',
        107: 'Optimizer step',
        108: 'Learning rate',
        109: 'Batch norm',
        110: 'Dropout apply',
        111: 'Convolution',
        112: 'Pooling',
        113: 'Flatten',
        114: 'Dense layer',
        115: 'Embedding lookup',
        116: 'Attention mechanism',
        117: 'Transformer block',
        118: 'Positional encoding',
        119: 'Tokenization',
        120: 'Vocabulary build',
        121: 'Sequence modeling',
        122: 'Time series',
        123: 'Signal processing',
        124: 'Fourier transform',
        125: 'Wavelet analysis',
        126: 'Filter design',
        127: 'Spectrum analysis',
        128: 'Noise reduction',
        129: 'Edge detection',
        130: 'Feature extraction',
        131: 'Pattern recognition',
        132: 'Object detection',
        133: 'Segmentation',
        134: 'Classification',
        135: 'Regression',
        136: 'Clustering',
        137: 'Dimension reduction',
        138: 'PCA analysis',
        139: 'LDA calculation',
        140: 'SVM training',
        141: 'Random forest',
        142: 'Decision tree',
        143: 'Naive bayes',
        144: 'KNN search',
        145: 'K-means cluster',
        146: 'Hierarchical cluster',
        147: 'DBSCAN',
        148: 'Gaussian mixture',
        149: 'EM algorithm',
        150: 'MCMC sampling',
        151: 'Bayesian inference',
        152: 'Markov chain',
        153: 'Hidden markov',
        154: 'Reinforcement learning',
        155: 'Q-learning',
        156: 'Policy gradient',
        157: 'Actor critic',
        158: 'DQN',
        159: 'A3C',
        160: 'PPO'
      },
      currentExecutingNode: '', // 当前执行的节点名称
      // 默认基础提示词
      basePrompt: 'JJJXXX, high-end nail product photo, ultra clean, remove dust and impurities, smooth surface, enhance gloss and transparency, soft studio lighting, high clarity, refined details, preserve original design, identical structure, no modification, do not change composition, do not alter shape, do not modify pattern, do not change color --neg no distortion, no redesign, no extra elements, no color shift, no deformation, no blur, no artifacts, no altered shape, no changed pattern, no low quality',
      // 批量处理相关
      batchQueue: [], // 待处理的图片队列
      batchResults: [], // 批量处理结果
      batchTotal: 0, // 批量总数
      batchCompleted: 0, // 批量已完成数
      isBatchProcessing: false // 是否正在批量处理
    }
  },
  computed: {
    canSend() {
      return this.uploadImages.length > 0
    }
  },
  created() {
    if (this.initialChatHistory && this.initialChatHistory.length > 0) {
      this.colorcardChatHistory = [...this.initialChatHistory]
    }
    // 从 sessionStorage 读取传递的提示词
    const savedPrompt = sessionStorage.getItem('colorcard_refine_prompt')
    if (savedPrompt) {
      // 延迟设置提示词，确保组件已挂载
      this.$nextTick(() => {
        this.textarea = savedPrompt
        console.log('从提示词优化页面传入的提示词:', savedPrompt)
        // 清除 sessionStorage 中的数据，避免下次进入时重复显示
        sessionStorage.removeItem('colorcard_refine_prompt')
      })
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPaste)
    // 点击外部关闭下拉菜单
    document.addEventListener('click', this.closeAllMenus)
    // 监听重新生成事件
    this.$root.$on('colorcard-regenerate', this.handleRegenerateFromParent)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPaste)
    document.removeEventListener('click', this.closeAllMenus)
    // 移除事件监听
    this.$root.$off('colorcard-regenerate', this.handleRegenerateFromParent)
  },
  methods: {
    // 处理图片上传（支持多选，最多10张）
    handleImageUpload() {
      if (this.processing) return
      const remaining = 10 - this.uploadImages.length
      if (remaining <= 0) {
        Message.warning('最多只能上传10张图片!')
        return
      }
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.multiple = true
      input.onchange = async (event) => {
        const files = Array.from(event.target.files)
        if (files.length === 0) return
        // 限制上传数量
        const toUpload = files.slice(0, remaining)
        if (files.length > remaining) {
          Message.warning(`最多还能上传${remaining}张图片，已自动截取前${remaining}张`)
        }
        for (const file of toUpload) {
          await this.processImage(file)
        }
      }
      input.click()
    },

    // 处理图片文件
    async processImage(file) {
      try {
        Message.info('正在上传图片...')
        const ossClient = await getOssClient()
        const tmp = '/input/'
        const fileName = `colorcard_${Date.now()}_${file.name}`
        const result = await ossClient.put(tmp + fileName, file)

        console.log('OSS上传结果:', result)

        if (result.name) {
          // 使用 result.name 构建 ComfyUI 可访问的 URL
          const imageUrl = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${result.name}`
          console.log('生成的图片URL:', imageUrl)

          this.uploadImages.push(imageUrl)
          Message.success('图片上传成功!')
        } else {
          Message.error('图片上传失败，请重试!')
        }
      } catch (error) {
        console.error('上传图片失败:', error)
        Message.error('图片上传失败，请检查网络!')
      }
    },

    // 移除图片（按索引）
    removeImage(index) {
      this.uploadImages.splice(index, 1)
    },

    // 关闭所有下拉菜单
    closeAllMenus() {
      // 当前没有下拉菜单需要关闭
    },

    // 处理 textarea 获得焦点
    handleTextareaFocus() {
      // 确保导航框处于放大状态
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 输入
    handleTextareaInput() {
      // 用户输入时保持放大状态
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 处理 textarea 失去焦点
    handleTextareaBlur() {
      // 不做任何处理，保持当前状态
    },
    // 处理 textarea 点击
    handleTextareaClick() {
      // 点击输入框时放大
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }
    },
    // 导航栏状态
    handleScroll(val) {
      if (val) {
        // 放大状态
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '70%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 1
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 1
        this.scrollStatus = true
      } else {
        // 缩小状态
        if (this.$refs.navigation_items) {
          this.$refs.navigation_items.style.width = '60%'
        }
        if (this.$refs.ai_assistant) this.$refs.ai_assistant.style.opacity = 0
        if (this.$refs.scroll_bottom) this.$refs.scroll_bottom.style.opacity = 0
        this.scrollStatus = false
      }
    },
    // 回滚到底部
    scrollToBottom() {
      if (this.scrollStatus) {
        this.$emit('scrollToBottom')
      }
    },

    // Ctrl+V 粘贴图片
    async handleKeyPaste(event) {
      if (event.ctrlKey && event.key === 'v') {
        try {
          const items = (event.clipboardData || window.clipboardData).items
          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
              const blob = items[i].getAsFile()
              await this.processImage(blob)
              break
            }
          }
        } catch (error) {
          console.error('粘贴图片失败:', error)
        }
      }
    },

    // 处理来自父组件的重新生成请求
    handleRegenerateFromParent(regenerateData) {
      if (!regenerateData) return
      console.log('接收到重新生成请求:', regenerateData)
      // 填充输入框和图片
      this.textarea = regenerateData.content
      this.uploadImages = regenerateData.images || []
      // 清除 sessionStorage
      sessionStorage.removeItem('colorcard_regenerate')
      // 自动触发生成
      this.$nextTick(() => {
        this.startTask()
      })
    },

    // 合并用户输入和基础提示词
    mergePrompt(userInput) {
      if (!userInput || userInput.trim() === '') {
        return this.basePrompt
      }
      // 将用户输入追加到基础提示词后面
      return `${this.basePrompt}, ${userInput.trim()}`
    },

    // 替换工作流中的动态变量
    replaceWorkflowVariables(workflow, seed, imageUrl, prompt, filename) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      console.log('🔍 开始替换工作流变量...')
      console.log('参数:', { seed, imageUrl, prompt })

      // 生成额外的随机种子
      const upscaleSeed = Math.floor(Math.random() * 100000000000000)
      const florenceSeed = Math.floor(Math.random() * 100000000000000)

      // 遍历所有节点替换变量
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{SEED}}')) {
                node.inputs[inputKey] = String(seed)
                console.log(`✅ 节点${nodeId}.${inputKey}: {{SEED}} -> ${seed}`)
              } else if (inputValue.includes('{{UPSCALE_SEED}}')) {
                node.inputs[inputKey] = upscaleSeed
                console.log(`✅ 节点${nodeId}.${inputKey}: {{UPSCALE_SEED}} -> ${upscaleSeed}`)
              } else if (inputValue.includes('{{FLORENCE_SEED}}')) {
                node.inputs[inputKey] = florenceSeed
                console.log(`✅ 节点${nodeId}.${inputKey}: {{FLORENCE_SEED}} -> ${florenceSeed}`)
              } else if (inputValue.includes('{{INPUT_IMAGE_URL}}')) {
                node.inputs[inputKey] = imageUrl
                console.log(`✅ 节点${nodeId}.${inputKey}: {{INPUT_IMAGE_URL}} -> ${imageUrl}`)
              } else if (inputValue.includes('{{OUTPUT_FILENAME}}')) {
                node.inputs[inputKey] = filename
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OUTPUT_FILENAME}} -> ${filename}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_ID}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeyId
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_ID}} -> ${this.ossConfig.accessKeyId}`)
              } else if (inputValue.includes('{{OSS_ACCESS_KEY_SECRET}}')) {
                node.inputs[inputKey] = this.ossConfig.accessKeySecret
                console.log(`✅ 节点${nodeId}.${inputKey}: {{OSS_ACCESS_KEY_SECRET}} -> [已隐藏]`)
              } else if (inputValue.includes('{{PROMPT}}')) {
                node.inputs[inputKey] = prompt
                console.log(`✅ 节点${nodeId}.${inputKey}: {{PROMPT}} -> ${prompt}`)
              }
            } else if (typeof inputValue === 'number') {
              // 处理数字类型的字段
              if (nodeId === '6' && inputKey === 'seed') {
                // 种子字段 - 替换为前端生成的随机种子
                node.inputs[inputKey] = seed
                console.log(`✅ 节点${nodeId}.${inputKey}: 替换为前端生成的种子 ${seed}`)
              }
            }
          }
        }
      }

      console.log('🔍 替换后的工作流:', JSON.stringify(workflowCopy, null, 2))
      return workflowCopy
    },

    // 开始任务（批量顺序处理）
    async startTask() {
      if (!this.canSend || this.processing) {
        return
      }

      // 确保放大状态
      if (!this.scrollStatus) {
        this.handleScroll(true)
      }

      if (this.uploadImages.length === 0) {
        Message.warning('请先上传图片!')
        return
      }

      const userMessage = this.textarea.trim()
      const userImages = [...this.uploadImages]

      // 合并提示词：基础提示词 + 用户输入
      const mergedPrompt = this.mergePrompt(userMessage)

      // 清空输入
      this.textarea = ''
      this.uploadImages = []

      // 初始化批量处理队列
      this.batchQueue = [...userImages]
      this.batchResults = []
      this.batchTotal = userImages.length
      this.batchCompleted = 0
      this.isBatchProcessing = true

      // 添加用户消息到历史（包含所有图片）
      this.colorcardChatHistory.push({
        role: 'user',
        content: userMessage || `使用默认设置进行色卡修图（共${userImages.length}张）`,
        images: userImages,
        timestamp: new Date().toISOString()
      })

      // 添加AI占位消息（用于显示加载框和结果）
      const imageSlots = userImages.map(() => ({ status: 'loading' }))
      this.colorcardChatHistory.push({
        role: 'assistant',
        content: '',
        imageSlots: imageSlots,
        totalImages: userImages.length,
        completedImages: 0,
        timestamp: new Date().toISOString()
      })

      // 更新界面
      this.$emit('chatUpdate', this.colorcardChatHistory)
      this.$emit('aiTyping', true)

      this.processing = true

      // 清空 textarea 后立即强制保持放大状态
      this.$nextTick(() => {
        this.handleScroll(true)
      })

      // 开始顺序处理第一张图片
      await this.processNextInBatch(mergedPrompt)
    },

    // 处理批量队列中的下一张图片
    async processNextInBatch(mergedPrompt) {
      if (this.batchQueue.length === 0) {
        // 所有图片处理完毕
        this.isBatchProcessing = false
        this.processing = false
        this.$emit('aiTyping', false)
        this.$emit('nodeUpdate', '')
        Message.success(`全部${this.batchTotal}张图片色卡修图完成!`)
        return
      }

      // 取出队列中的第一张
      const currentImage = this.batchQueue.shift()
      console.log(`🖼️ 正在处理第 ${this.batchCompleted + 1}/${this.batchTotal} 张图片`)

      try {
        // 生成随机种子
        const seed = Math.floor(Math.random() * 100000000000000)
        // 生成动态文件名（必须是JSON数组格式的字符串）
        const timestamp = Date.now()
        const randomNum = Math.floor(Math.random() * 99999)
        const filename = `["tmp-comfyui/colorcard/${timestamp}_${randomNum}.png"]`

        console.log('🎲 生成的种子:', seed)
        console.log('🖼️ 当前图片URL:', currentImage)
        console.log('📝 合并后的提示词:', mergedPrompt)

        // 替换工作流变量
        const promptData = this.replaceWorkflowVariables(
          colorCardWorkflow,
          seed,
          currentImage,
          mergedPrompt,
          filename
        )

        this.clientId = uuidv4()
        const data = {
          prompt: promptData,
          client_id: this.clientId
        }

        console.log('🚀 准备发送色卡修图任务...')

        // 发送 Prompt 请求
        const result = await genPrompt(data)

        if (result && result.prompt_id) {
          console.log('✅ 任务提交成功，promptId:', result.prompt_id)
          // 监听 WebSocket 进度
          await this.listenToBatchProgress(result.prompt_id, mergedPrompt, currentImage)
        } else {
          throw new Error('任务提交失败')
        }
      } catch (error) {
        console.error('❗ 色卡修图失败:', error)
        let errorMessage = '色卡修图失败，请稍后再试!'
        if (error.response) {
          errorMessage = `服务器错误: ${error.response.status}`
        } else if (error.message) {
          errorMessage = error.message
        }
        // 标记当前图片为失败
        this.batchCompleted++
        this.batchResults.push({ image: currentImage, error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.colorcardChatHistory)
        Message.error(errorMessage)
        // 继续处理下一张
        await this.processNextInBatch(mergedPrompt)
      }
    },

    // 监听批量处理中单张图片的进度
    async listenToBatchProgress(promptId, mergedPrompt, taskImage) {
      this.imageFetched = false
      this.ws = new WebSocket(`${getWebSocketUrl()}/ws?clientId=${this.clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时，尝试继续获取结果...')
        this.ws.close()
        // 超时后尝试直接获取结果
        if (!this.imageFetched) {
          this.imageFetched = true
          this.fetchBatchResultImage(promptId, mergedPrompt)
        }
      }, 30000)
      this.ws.onopen = () => {
        console.log('✅ WebSocket 连接成功')
        // 记录任务开始
        getTaskStart({
          type: T_COLOR_CARD_RETouchING,
          prompt: mergedPrompt || '',
          input_images: taskImage ? [taskImage] : []
        }).then(rep => {
          this.taskLogId = rep.data.task.id
          this.$emit('taskLogId', this.taskLogId)
        })
        clearTimeout(wsTimeout)
      }
      this.ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(data)
            if (msg.type !== 'crystools.monitor') {
              console.log('📡 收到消息:', msg)
            }

            if (msg.type === 'executing') {
              const execData = msg.data
              if (execData.node === null && execData.prompt_id === promptId) {
                console.log(`✅ 第 ${this.batchCompleted + 1}/${this.batchTotal} 张色卡修图完成`)
                this.currentExecutingNode = ''
                this.$emit('nodeUpdate', '')
                this.ws.close()
                if (!this.imageFetched) {
                  this.imageFetched = true
                  await this.fetchBatchResultImage(promptId, mergedPrompt)
                }
              } else if (execData.node !== null) {
                const nodeName = this.nodeNameMap[execData.node] || `Executing node ${execData.node}`
                this.currentExecutingNode = `${nodeName} (${this.batchCompleted + 1}/${this.batchTotal})`
                this.$emit('nodeUpdate', this.currentExecutingNode)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              this.$emit('progressUpdate', current)
            } else if (msg.type === 'execution_error') {
              console.error('❌ 执行错误:', msg.data)
              this.batchCompleted++
              this.batchResults.push({ image: '', error: true })
              this.updateAssistantMessage()
              this.$emit('chatUpdate', this.colorcardChatHistory)
              Message.error(`第 ${this.batchCompleted} 张图片色卡修图失败`)
              this.ws.close()
              // 继续处理下一张
              await this.processNextInBatch(mergedPrompt)
            }
          } catch (error) {
            console.error('WebSocket消息解析失败:', error)
          }
        }
      }
      this.ws.onclose = async () => {
        console.log('🔌 WebSocket 连接关闭')
        try {
          const index = await cudaIndexNum()
          if (index) {
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.ws.onerror = (error) => {
        console.error('❌ WebSocket 错误:', error)
        // WS连接错误时不直接中断流程，等待一段时间后尝试获取结果
        setTimeout(async () => {
          if (!this.imageFetched) {
            console.log('🔄 WS错误后尝试检查任务结果...')
            this.imageFetched = true
            await this.fetchBatchResultImage(promptId, mergedPrompt)
          }
        }, 3000)
      }
    },

    // 获取批量处理中单张结果图片
    async fetchBatchResultImage(promptId, mergedPrompt) {
      try {
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: { 'Content-Type': 'application/json' }
        })
        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        if (promptInfo.status.status_str === 'success') {
          const promptIndex = 2
          const nodeId = '116'
          console.log('📄 历史记录结构:', JSON.stringify(promptInfo.prompt, null, 2))
          if (!promptInfo.prompt || !promptInfo.prompt[promptIndex] || !promptInfo.prompt[promptIndex][nodeId]) {
            console.error(`历史记录结构异常，无法找到节点${nodeId}的数据`)
            console.error('可用的prompt索引:', Object.keys(promptInfo.prompt || {}))
            if (promptInfo.prompt && promptInfo.prompt[promptIndex]) {
              console.error('该索引下的节点:', Object.keys(promptInfo.prompt[promptIndex]))
            }
            this.batchCompleted++
            this.batchResults.push({ image: '', error: true })
            this.updateAssistantMessage()
            this.$emit('chatUpdate', this.colorcardChatHistory)
            await this.processNextInBatch(mergedPrompt)
            return
          }
          const filenameStr = promptInfo.prompt[promptIndex][nodeId].inputs.filename
          const tmp = JSON.parse(filenameStr)
          const imageUrl = genOssImage(tmp[0])
          console.log(`✅ 第 ${this.batchCompleted + 1} 张图片URL:`, imageUrl)

          // 记录结果
          this.batchCompleted++
          this.batchResults.push({ image: imageUrl, error: false })

          // 更新AI消息
          this.updateAssistantMessage()
          this.$emit('chatUpdate', this.colorcardChatHistory)

          // 记录任务结束
          await this.recordTaskEnd(imageUrl)

          // 继续处理下一张
          await this.processNextInBatch(mergedPrompt)
        } else {
          this.batchCompleted++
          this.batchResults.push({ image: '', error: true })
          this.updateAssistantMessage()
          this.$emit('chatUpdate', this.colorcardChatHistory)
          Message.error(`第 ${this.batchCompleted} 张图片色卡修图失败`)
          await this.processNextInBatch(mergedPrompt)
        }
      } catch (error) {
        console.error('获取图片失败：', error)
        this.batchCompleted++
        this.batchResults.push({ image: '', error: true })
        this.updateAssistantMessage()
        this.$emit('chatUpdate', this.colorcardChatHistory)
        Message.error('获取生成结果失败')
        await this.processNextInBatch(mergedPrompt)
      }
    },

    // 更新AI占位消息（实时更新slot状态）
    updateAssistantMessage() {
      // 找到最后一条AI消息
      let lastAiIndex = -1
      for (let i = this.colorcardChatHistory.length - 1; i >= 0; i--) {
        if (this.colorcardChatHistory[i].role === 'assistant') {
          lastAiIndex = i
          break
        }
      }
      if (lastAiIndex === -1) return

      const aiMessage = this.colorcardChatHistory[lastAiIndex]

      // 确保 imageSlots 存在
      if (!aiMessage.imageSlots) {
        aiMessage.imageSlots = []
        for (let i = 0; i < this.batchTotal; i++) {
          aiMessage.imageSlots.push({ status: 'loading' })
        }
      }

      // 根据batchResults更新对应slot
      for (let i = 0; i < this.batchResults.length; i++) {
        const result = this.batchResults[i]
        if (result.error) {
          aiMessage.imageSlots[i] = { status: 'error' }
        } else {
          aiMessage.imageSlots[i] = { status: 'done', image: result.image }
        }
      }

      // 更新已完成数
      aiMessage.completedImages = this.batchCompleted

      // 如果全部完成
      if (this.batchCompleted >= this.batchTotal) {
        const successCount = this.batchResults.filter(r => !r.error).length
        aiMessage.content = successCount > 0
          ? `色卡修图完成！成功 ${successCount}/${this.batchTotal} 张`
          : '抱歉，所有图片修图均失败'
        aiMessage.isError = successCount === 0
      }
      // 强制响应式更新
      this.$set(this.colorcardChatHistory, lastAiIndex, { ...aiMessage })
    },

    // 记录任务结束
    async recordTaskEnd(imageUrl) {
      try {
        const imgInfo = await getImageSizeByLoading(imageUrl)
        const info = {
          details: [{ path: imageUrl, imgInfo: imgInfo }]
        }
        await getTaskEnd({ result: JSON.stringify(info) }, this.taskLogId)
      } catch (error) {
        console.error('记录任务结束失败:', error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.active {
  background: @basicselect;
}

.navigation {
  position: absolute;
  width: calc(100vw - 80px);
  bottom: 15px;
  left: 100px;
  z-index: 8;
  transition: all 0.5s;

  .navigation_bottom {
    position: relative;
    width: 1536px;
    height: 50px;
    font-size: 23px;
    margin: 0 auto;
    justify-content: space-between;
    margin-bottom: 10px;

    .ai_assistant {
      position: absolute;
      bottom: -10px;
      width: 120px;
      height: 120px;
      opacity: 0;
      transition: all 0.5s;
    }

    .scroll_bottom {
      position: absolute;
      right: 0px;
      font-size: 20px;
      color: @font_white;
      background-color: #c1c1c1;
      padding: 10px 15px;
      cursor: pointer;
      border-radius: @border_radius_3;
      transition: all 0.5s;
      opacity: 0;
    }
  }

  .navigation_items {
    position: relative;
    width: 1336px;
    height: 220px;
    display: flex;
    flex-direction: column;
    background: rgba(235, 235, 235, 0.5);
    backdrop-filter: blur(10px);
    border: 1px solid @font_white;
    border-radius: @border_radius;
    transition: all 0.3s;
    margin: 0 auto;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.2);

    .main_input {
      width: 100%;
      height: 220px;
      display: flex;
      flex-direction: column;
      padding: 15px 20px;
      gap: 10px;

      // 已上传图片缩略图区域
      .uploaded-thumbnails {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
        overflow-x: auto;
        padding: 4px 0;
        flex-shrink: 0;
        height: 68px;

        &::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d0d0d0;
          border-radius: 2px;
        }

        .thumbnail-item {
          position: relative;
          width: 60px;
          height: 60px;
          border-radius: 8px;
          overflow: hidden;
          flex-shrink: 0;
          border: 2px solid #e5e7eb;
          transition: all 0.3s;

          &:hover {
            border-color: @morejoy;
            transform: scale(1.05);
          }

          .thumbnail-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .remove-btn {
            position: absolute;
            top: 2px;
            right: 2px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.6);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            cursor: pointer;
            transition: all 0.3s;
            line-height: 1;

            &:hover {
              background: rgba(255, 0, 0, 0.8);
              transform: scale(1.1);
            }
          }
        }
      }

      // 输入框区域
      .input-area {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 15px;
        position: relative;
        min-height: 60px;

        textarea {
          flex: 1;
          height: 100%;
          min-height: 60px;
          font-family: '微软雅黑';
          font-size: 23px;
          padding: 10px 20px;
          border: none;
          background: none;
          resize: none;
          outline: none;
        }

        .sent {
          position: absolute;
          right: 0;
          width: 60px;
          height: 60px;
          text-align: center;
          line-height: 60px;
          font-size: 35px;
          color: @font_white;
          border: none;
          border-radius: 30px;
          background-color: @font_gray;
          cursor: pointer;
          opacity: 0.7;
          transition: all 0.3s;

          &.has_input {
            background-color: @morejoy;
            opacity: 1;
          }

          &:hover:not(:disabled) {
            opacity: 1;
            font-size: 38px;
          }

          &:disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }

          .rotating {
            animation: rotate 1s linear infinite;
          }
        }
      }

      // 底部按钮区域
      .input-options {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        height: 40px;

        .option-btn {
          position: relative;
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 12px;
          background: white;
          border: 1px solid #d0d0d0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          user-select: none;
          font-size: 13px;
          color: #333;
          font-weight: 500;

          &:hover {
            border-color: @morejoy;
            background: #fff8f3;
          }
        }
      }

      // 上传区域容器
      .upload-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        flex-shrink: 0;
      }

      // 多图上传缩略图区域
      .upload-thumbnails {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
        max-width: 500px;
        overflow-x: auto;
        padding: 4px 0;

        &::-webkit-scrollbar {
          height: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d0d0d0;
          border-radius: 2px;
        }

        .thumbnail-item {
          position: relative;
          width: 70px;
          height: 70px;
          border-radius: 8px;
          overflow: hidden;
          flex-shrink: 0;
          border: 2px solid #e5e7eb;
          transition: all 0.3s;

          &:hover {
            border-color: @morejoy;
            transform: scale(1.05);
          }

          .thumbnail-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .remove-btn {
            position: absolute;
            top: 2px;
            right: 2px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.6);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            cursor: pointer;
            transition: all 0.3s;
            line-height: 1;

            &:hover {
              background: rgba(255, 0, 0, 0.8);
              transform: scale(1.1);
            }
          }

          .thumbnail-index {
            position: absolute;
            bottom: 2px;
            left: 2px;
            width: 16px;
            height: 16px;
            background: rgba(0, 0, 0, 0.5);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 10px;
            line-height: 1;
          }
        }

        // 上传添加按钮
        .upload-add-btn {
          width: 70px;
          height: 70px;
          border: 2px dashed #d0d0d0;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 4px;
          cursor: pointer;
          transition: all 0.3s;
          flex-shrink: 0;
          background: white;

          &:hover {
            border-color: @morejoy;
            background: #fff8f3;
          }

          .upload-plus {
            font-size: 24px;
            color: #999;
            font-weight: 300;
            line-height: 1;
          }

          .upload-label {
            font-size: 11px;
            color: #666;
          }
        }
      }

      // 输入框内按钮区域 - 参照视频生成样式
      .input-options {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;

        .option-btn {
          position: relative;
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 12px;
          background: white;
          border: 1px solid #d0d0d0;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          user-select: none;
          font-size: 13px;
          color: #333;
          font-weight: 500;

          &:hover {
            border-color: @morejoy;
            background: #fff8f3;
          }
        }
      }
    }

    /* 放大后的发送按钮（绝对定位） */
    .sent_expanded {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      font-size: 35px;
      color: @font_white;
      border: none;
      border-radius: 30px;
      background-color: @font_gray;
      cursor: pointer;
      opacity: 0.7;
      transition: all 0.3s;
      z-index: 10;

      &.has_input {
        background-color: @morejoy; // 有输入时变成橙色
        opacity: 1;
      }

      &:hover:not(:disabled) {
        opacity: 1;
        font-size: 38px;
      }

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }

      .rotating {
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
